<template lang="pug">
.app-shell
  a.skip-link(href="#main-content") {{ locale === 'zh' ? '跳至主要內容' : 'Skip to content' }}
  .container-fluid.site-header(:inert="mobileMenuOpen || searchOpen || undefined")
    .row
      .col-sm-12
        nav(
          v-if="!$route.path.includes('manage')",
          :aria-label="locale === 'zh' ? '主要導覽' : 'Main navigation'"
        )
          router-link.main-logo(:to="localizedPath('/')", :aria-label="locale === 'zh' ? '吳哲宇，首頁' : 'Che-Yu Wu, home'")
            //- 2026-10-04 標誌換成內聯 SVG（原本兩張白色 PNG 共 76 KB、兩張都會下載）；PNG 檔留著，別處還在用
            h2.d-none.d-md-block
              brand-logo(variant="primary")
            h2.d-md-none
              brand-logo(variant="symbol")
          //- Desktop nav
          .subroute.d-none.d-xl-flex(:class="{ white: $route.path == '/cv' || $route.path == '/muse' }")
            //- 2026-10-03 哲宇：「關於要移動到作品與展覽前面」
            router-link(
              :to="localizedPath('/about')",
              :class="{ active: $route.path.includes('/about') }"
            ) {{ $t('nav.about') }}
            router-link(
              :to="localizedPath('/work')",
              :class="{ active: $route.path.includes('/work') || $route.path == '/arts' || $route.path.includes('/nft') || $route.path.includes('/exhibition') }"
            ) {{ $t('nav.work') }}
            router-link(:to="localizedPath('/strata')", :title="$t('nav.strataSub')") {{ $t('nav.strata') }}
            router-link(:to="localizedPath('/lab')", :title="$t('nav.labSub')") {{ $t('nav.lab') }}
            router-link(
              :to="localizedPath('/music')",
              :class="{ active: $route.path.includes('/music') }"
            ) {{ $t('nav.music') }}
            router-link(
              :to="localizedPath('/thinking')",
              :class="{ active: $route.path.includes('/thinking') || $route.path.includes('/writing') || $route.path.includes('/dialogues') }"
            ) {{ $t('nav.thinking') }}
            //- 2026-10-16 教學頁（第一個獨立的教學頁）：放在思想後面
            router-link(
              :to="localizedPath('/teaching')",
              :class="{ active: $route.path.includes('/teaching') }"
            ) {{ $t('nav.teaching') }}
            router-link(
              :to="localizedPath('/press')",
              :class="{ active: $route.path.includes('/press') }"
            ) {{ $t('nav.press') }}
            a(href="https://muse.cheyuwu.com/", target="_blank", rel="noopener noreferrer") {{ $t('nav.muse') }}
            router-link(
              :to="localizedPath('/contact')",
              :class="{ active: $route.path.includes('/contact') }"
            ) {{ $t('nav.contact') }}
            button.search-btn(
              type="button", aria-haspopup="dialog", aria-keyshortcuts="Control+K Meta+K /",
              :aria-label="locale === 'zh' ? '搜尋全站（⌘K）' : 'Search the site (⌘K)'",
              :title="locale === 'zh' ? '搜尋全站（⌘K）' : 'Search the site (⌘K)'",
              @click="openSearch", @pointerenter="warmSearch", @focus="warmSearch"
            )
              svg(viewBox="0 0 24 24", width="20", height="20", aria-hidden="true", focusable="false")
                circle(cx="10.5", cy="10.5", r="6.5", fill="none", stroke="currentColor", stroke-width="1.8")
                path(d="M15.5 15.5 21 21", stroke="currentColor", stroke-width="1.8", stroke-linecap="round")
            language-switcher
            a.nav-icon(href="https://www.instagram.com/cheyuwu345/", target="_blank", rel="noopener noreferrer", aria-label="Instagram")
              Icon(name="instagram")
          //- Mobile hamburger button（左邊多一個搜尋 icon）
          .mobile-actions.d-xl-none
            button.search-btn(
              type="button", aria-haspopup="dialog",
              :aria-label="locale === 'zh' ? '搜尋全站' : 'Search the site'",
              @click="openSearch", @pointerenter="warmSearch", @focus="warmSearch"
            )
              svg(viewBox="0 0 24 24", width="20", height="20", aria-hidden="true", focusable="false")
                circle(cx="10.5", cy="10.5", r="6.5", fill="none", stroke="currentColor", stroke-width="1.8")
                path(d="M15.5 15.5 21 21", stroke="currentColor", stroke-width="1.8", stroke-linecap="round")
            button.hamburger(
              ref="menuToggle", type="button", aria-controls="mobile-navigation",
              :aria-expanded="mobileMenuOpen",
              :aria-label="locale === 'zh' ? '開啟導覽' : 'Open navigation'",
              @click="mobileMenuOpen = !mobileMenuOpen",
              :class="{ open: mobileMenuOpen }"
            )
              span
              span
              span

  //- Mobile fullscreen menu overlay
  transition(name="menu-fade")
    .mobile-menu-overlay#mobile-navigation(v-if="mobileMenuOpen", ref="menuPanel", role="dialog", aria-modal="true", :aria-label="locale === 'zh' ? '網站導覽' : 'Site navigation'", @click.self="mobileMenuOpen = false")
      button.menu-close(type="button", @click="mobileMenuOpen = false") {{ locale === 'zh' ? '關閉 ×' : 'Close ×' }}
      .mobile-menu-content
        router-link(:to="localizedPath('/about')", @click="mobileMenuOpen = false") {{ $t('nav.about') }}
        router-link(:to="localizedPath('/work')", @click="mobileMenuOpen = false") {{ $t('nav.work') }}
        router-link(:to="localizedPath('/strata')", @click="mobileMenuOpen = false") {{ $t('nav.strata') }}
          small.menu-sub {{ $t('nav.strataSub') }}
        router-link(:to="localizedPath('/lab')", @click="mobileMenuOpen = false") {{ $t('nav.lab') }}
          small.menu-sub {{ $t('nav.labSub') }}
        router-link(:to="localizedPath('/music')", @click="mobileMenuOpen = false") {{ $t('nav.music') }}
        router-link(:to="localizedPath('/thinking')", @click="mobileMenuOpen = false") {{ $t('nav.thinking') }}
        router-link(:to="localizedPath('/teaching')", @click="mobileMenuOpen = false") {{ $t('nav.teaching') }}
        router-link(:to="localizedPath('/press')", @click="mobileMenuOpen = false") {{ $t('nav.press') }}
        a(href="https://muse.cheyuwu.com/", target="_blank", rel="noopener noreferrer", @click="mobileMenuOpen = false") {{ $t('nav.muse') }}
        router-link(:to="localizedPath('/contact')", @click="mobileMenuOpen = false") {{ $t('nav.contact') }}
        language-switcher.mt-3(@click="mobileMenuOpen = false")
        a.menu-social(href="https://www.instagram.com/cheyuwu345/", target="_blank", rel="noopener noreferrer")
          Icon(name="instagram")
          |  Instagram
  //- 全站搜尋浮層（lazy：第一次開啟或 hover／focus 搜尋 icon 時才載入程式碼與索引）
  SearchOverlay(v-if="searchOpen", :locale="locale", @close="closeSearch")
  //- 開場（簽名入座）在 index.html＋runtime/intro-seat.mjs（#app 之外，第一次繪製就開始畫）
  //- 換頁銜接改由 View Transitions 負責（runtime/view-transition.js）：舊頁不再淡出到黑、新頁與舊頁重疊。
  //- 不支援或減少動態時，新頁掛載時只做進場淡入（onPageMounted），舊頁立即移除。
  main#main-content(tabindex="-1", :inert="mobileMenuOpen || searchOpen || undefined")
    router-view(v-slot="{ Component }")
      component(:is="Component", :key="$route.path", @vue:mounted="onPageMounted")

  //- thesis runs a full-height interactive canvas; the footer would fight it.
  //- Path check covers both locales (was English-only before 2026-08-10).
  footer.site-footer(v-if="!$route.path.endsWith('/thesis') && !$route.path.endsWith('/thesis/')", :inert="mobileMenuOpen || searchOpen || undefined")
    .footer-inner
      .footer-col
        .footer-title {{ $t('footer.site') }}
        router-link(:to="localizedPath('/about')") {{ $t('nav.about') }}
        router-link(:to="localizedPath('/work')") {{ $t('nav.work') }}
        router-link(:to="localizedPath('/music')") {{ $t('nav.music') }}
        router-link(:to="localizedPath('/thinking')") {{ $t('nav.thinking') }}
        router-link(:to="localizedPath('/teaching')") {{ $t('nav.teaching') }}
        router-link(:to="localizedPath('/press')") {{ $t('nav.press') }}
        router-link(:to="localizedPath('/contact')") {{ $t('nav.contact') }}
        //- 2026-10-04 網站地圖旁放 2023 品牌圖示 Map（樹狀圖＝/sitemap/ 的拓樸圖），文字保留
        router-link.footer-map(:to="localizedPath('/sitemap')")
          brand-icon(name="map")
          | {{ locale === 'zh' ? '網站地圖' : 'Sitemap' }}
        a(href="/ai/") {{ locale === 'zh' ? 'AI 閱讀指南' : 'AI reading guide' }}
      .footer-col
        .footer-title {{ $t('footer.archive') }}
        router-link(:to="localizedPath('/work')") {{ locale === 'zh' ? '瀏覽作品檔案' : 'Browse the archive' }}
        router-link(:to="localizedPath('/strata')") {{ $t('nav.strata') }}：{{ $t('nav.strataSub') }}
        router-link(:to="localizedPath('/lab')") {{ $t('nav.lab') }}：{{ $t('nav.labSub') }}
        router-link(:to="localizedPath('/cv')") {{ locale === 'zh' ? '完整履歷' : 'Curriculum vitae' }}
        router-link(:to="localizedPath('/dialogues')") {{ locale === 'zh' ? '對話錄' : 'Dialogues' }}
        //- 2026-08-10: these four were hardcoded to the English paths, so a visitor
        //-   browsing in Chinese got kicked back to /en on every archive link.
        router-link(:to="localizedPath('/lineage')") {{ locale === 'zh' ? '創作族譜' : 'Family tree' }}
          span.footer-era 2018–2026
        router-link(:to="localizedPath('/nft')") {{ $t('footer.nftCatalog') }}
          span.footer-era 2021–2024
        router-link(:to="localizedPath('/thesis')") {{ $t('footer.thesis') }}
          span.footer-era NYU · 2019
        router-link(:to="localizedPath('/research')") {{ $t('footer.research') }}
          span.footer-era NYU · 2018
        router-link(:to="localizedPath('/experiment')") {{ $t('footer.experiments') }}
          span.footer-era 2018–2019
      //- 2026-10-04 哲宇：「把 openaudiovisual.com 加入到 footer，可以開一個欄位是專案之類的」
      .footer-col.footer-projects
        .footer-title {{ $t('footer.projects') }}
        //- 年份只寫查得到的（服務總表的上線日）；MonoLab 沒有確切起始年，不標
        //- 互動程式創作台灣站標的是文章年份（2020–2023 教學庫，creativecoding.in/llms.txt；2026-10-22 交叉連結策略報告）
        a(href="https://taiwan.md/", target="_blank", rel="noopener") Taiwan.md
          span.footer-era 2026
        a(href="https://openaudiovisual.com/", target="_blank", rel="noopener") Open AudioVisual
          span.footer-era 2026
        a(href="https://webtoe.openaudiovisual.com/", target="_blank", rel="noopener") WebToe
          span.footer-era 2026
        a(href="https://frank890417.github.io/open-dictate/", target="_blank", rel="noopener") Open Dictate
          span.footer-era 2026
        a(href="https://muse.cheyuwu.com/", target="_blank", rel="noopener") Muse
          span.footer-era 2026
        a(href="https://creativecoding.in/", target="_blank", rel="noopener") {{ locale === 'zh' ? '互動程式創作台灣站' : 'Creative Coding TW' }}
          span.footer-era 2020–2023
        a(href="https://monolab.world/", target="_blank", rel="noopener") MonoLab
      .footer-col
        .footer-title {{ $t('footer.elsewhere') }}
        a(href="https://www.instagram.com/cheyuwu345/", target="_blank", rel="noopener") Instagram
        a(href="https://github.com/frank890417", target="_blank", rel="noopener") GitHub
        a(href="https://www.fxhash.xyz/u/Che-Yu%20Wu", target="_blank", rel="noopener") fxhash
        a(href="https://open.spotify.com/artist/0AeZiCXhHzvexu47FOY5Tq", target="_blank", rel="noopener") Spotify
    .footer-base
      label {{ $t('common.copyright') }}, {{ $t('common.year') }}
      .text-center.mt-2
        social-links
</template>

<script>
import { startSmoothScroll, pauseSmoothScroll, pageReady, hashTarget, scrollToElement } from './runtime/smooth-scroll'
import { consumeEnterMode } from './runtime/view-transition'
import { markCompleteImages } from './runtime/image-reveal'
import { observeVisibleLinks } from './runtime/prefetch'
import { trackEvent } from './runtime/analytics.mjs'
import { composeTitle, ogTitle } from './runtime/page-title.mjs'
import { withSlash } from './runtime/site-path.mjs'
import socialLinks from "@/components/socialLinks.vue";
import Icon from "@/components/ui/Icon.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import BrandLogo from "@/components/BrandLogo.vue";
import BrandIcon from "@/components/BrandIcon.vue";
import { useMainStore } from "@/store";
import { useHead } from "@unhead/vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { computed, ref, watch, nextTick, onMounted, onBeforeUnmount, defineAsyncComponent } from "vue";
// 搜尋浮層：第一次開啟（或 hover／focus 搜尋 icon）才載入，首頁初次載入不含搜尋程式碼與索引
const loadSearchOverlay = () => import("@/components/search/SearchOverlay.vue");
const SearchOverlay = defineAsyncComponent(loadSearchOverlay);

export default {
  name: "app",
  components: {
    Icon,
    "social-links": socialLinks,
    LanguageSwitcher,
    BrandLogo,
    BrandIcon,
    SearchOverlay,
  },
  setup() {
    const store = useMainStore();
    const route = useRoute();
    const router = useRouter();
    const { locale } = useI18n();
    const mobileMenuOpen = ref(false);
    const menuToggle = ref(null);
    const menuPanel = ref(null);
    const searchOpen = ref(false);
    let searchOpener = null;
    let previousOverflow = null;
    let destroySmoothScroll;
    const restoreScroll = () => {
      if (previousOverflow !== null) {
        document.body.style.overflow = previousOverflow;
        previousOverflow = null;
      }
    };
    watch(mobileMenuOpen, async (open) => {
      pauseSmoothScroll(open);
      if (open) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        await nextTick();
        menuPanel.value?.querySelector('button')?.focus();
      } else {
        restoreScroll();
        await nextTick();
        menuToggle.value?.focus();
      }
    });
    const handleMenuKey = (event) => {
      if (!mobileMenuOpen.value) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        mobileMenuOpen.value = false;
      }
      if (event.key === 'Tab') {
        const focusable = [...(menuPanel.value?.querySelectorAll('a[href], button:not([disabled])') || [])];
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !menuPanel.value?.contains(document.activeElement))) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !menuPanel.value?.contains(document.activeElement))) {
          event.preventDefault(); first?.focus();
        }
      }
    };
    // 全站搜尋：⌘K／Ctrl+K 開關，`/`（焦點不在輸入框時）開啟，關閉後焦點回到搜尋 icon
    const visibleSearchButton = () => [...document.querySelectorAll('.search-btn')].find(el => el.offsetParent !== null);
    const warmSearch = () => {
      loadSearchOverlay().catch(() => {});
      import('./search/client.mjs').then(m => m.prefetchSearch(locale.value === 'zh' ? 'zh' : 'en')).catch(() => {});
    };
    const openSearch = (event) => {
      if (event?.currentTarget instanceof Element) searchOpener = event.currentTarget;
      mobileMenuOpen.value = false;
      searchOpen.value = true;
    };
    const closeSearch = async (restoreFocus = true) => {
      if (!searchOpen.value) return;
      searchOpen.value = false;
      await nextTick();
      if (restoreFocus === false) return;
      const target = searchOpener?.isConnected && searchOpener.offsetParent !== null ? searchOpener : visibleSearchButton();
      target?.focus();
    };
    const handleSearchKey = (event) => {
      if (route.path.includes('manage')) return;
      const key = event.key;
      if ((event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey && key.toLowerCase() === 'k') {
        event.preventDefault();
        if (searchOpen.value) closeSearch(); else { searchOpener = visibleSearchButton(); warmSearch(); openSearch(); }
        return;
      }
      if (key === '/' && !searchOpen.value && !mobileMenuOpen.value && !event.metaKey && !event.ctrlKey && !event.altKey) {
        const el = event.target;
        if (el?.closest?.('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return;
        event.preventDefault();
        searchOpener = visibleSearchButton();
        openSearch();
      }
    };
    const handleHashClick = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const a = event.target?.closest?.('a[href^="#"]');
      if (!a || a.classList.contains('skip-link')) return;
      const hash = a.getAttribute('href');
      const target = hashTarget(hash);
      if (!target || hash.length < 2) return;
      event.preventDefault();
      const land = () => {
        if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      };
      if (route.hash === hash) { scrollToElement(target, { smooth: true }); land(); return; }
      // 明寫 path：只給 hash 時 vue-router 會用路由名稱重組出帶尾斜線的路徑，被當成換頁而整頁重掛
      router.push({ path: route.path, query: route.query, hash }).then(land, land);
    };
    const handleResize = () => {
      if (window.innerWidth >= 1200) mobileMenuOpen.value = false;
    };
    onMounted(() => {
  // 外連點擊（2026-09-14 稽核：整站除了 lab 沒有任何互動事件）。只送 origin+pathname，analytics.mjs 會把 query 剝掉。
  document.addEventListener('click', event => {
    const a = event.target?.closest?.('a[href]')
    if (!a) return
    let url; try { url = new URL(a.href, location.href) } catch { return }
    if (url.origin === location.origin || !/^https?:$/.test(url.protocol)) return
    trackEvent('outbound_click', { link_url: url.href, link_domain: url.hostname, link_text: (a.textContent || '').trim().slice(0, 60) })
  }, { passive: true })
      destroySmoothScroll = startSmoothScroll();
      // 頁內錨點（作品目錄、文章綱要、About 章節…）改由 router 帶 hash：Lenis 滑行 560ms，
      // 取代瀏覽器瞬跳＋350ms 後再跳一次（2026-09-25 動態設計 P10）。跳至主要內容維持原生行為。
      document.addEventListener('click', handleHashClick);
      document.addEventListener('keydown', handleMenuKey);
      document.addEventListener('keydown', handleSearchKey);
      window.addEventListener('resize', handleResize);
    });
    onBeforeUnmount(() => {
      destroySmoothScroll?.();
      document.removeEventListener('click', handleHashClick);
      document.removeEventListener('keydown', handleMenuKey);
      document.removeEventListener('keydown', handleSearchKey);
      window.removeEventListener('resize', handleResize);
      restoreScroll();
    });

    const loading = computed(() => store.loading);
    
    // Function to generate localized paths
    const localizedPath = (path) => {
      const currentLocale = locale.value;
      // 正式形狀：語言前綴＋結尾斜線（runtime/site-path.mjs）
      return withSlash(currentLocale === 'zh' ? '/zh' + path : path);
    };

    // Close menu on route change
    watch(() => route.path, () => {
      mobileMenuOpen.value = false;
      searchOpen.value = false;
    });

    // Keep the UI locale in step with the URL on client-side navigation
    watch(() => route.path, (p) => {
      const want = (p === '/zh' || p.startsWith('/zh/')) ? 'zh' : 'en';
      if (locale.value !== want) locale.value = want;
    }, { immediate: true });

    const SITE = 'https://cheyuwu.com';
    const isZhPath = computed(() => route.path === '/zh' || route.path.startsWith('/zh/'));
    // Canonical form: absolute, no query/hash, trailing slash on directory-style routes (Pages serves them that way)
    const publicEntry = computed(() => route.meta?.publicEntry);
    const canonicalPath = computed(() => {
      let p = route.path || '/';
      if (p !== '/' && !p.endsWith('/') && !/\.[a-z0-9]+$/i.test(p)) p += '/';
      return p;
    });
    const canonicalUrl = computed(() => SITE + canonicalPath.value);
    const alternateLinks = computed(() => {
      const paths = publicEntry.value?.alternates || [];
      const links = paths.map(p => ({ rel: 'alternate', hreflang: p.startsWith('/zh/') ? 'zh-Hant' : 'en', href: SITE + p }));
      if (paths.length) links.push({ rel: 'alternate', hreflang: 'x-default', href: SITE + (paths.find(p => !p.startsWith('/zh/')) || paths[0]) });
      return links;
    });
    const pageTitle = computed(() => route.meta?.title || 'Che-Yu Wu 吳哲宇');
    const siteName = 'Che-Yu Wu 吳哲宇';
    // og:title／twitter:title 用頁面主體（不含作者後綴）
    const shareTitle = computed(() => ogTitle(route.meta?.title, isZhPath.value ? 'zh' : 'en'));
    const shareImage = computed(() => publicEntry.value?.image || SITE + '/static/img/og-2026-10.jpg');
    // 圖片尺寸：預設圖已知是 1200×630；其他圖由 route manifest 讀實際像素（imageW／imageH），讀不到（外站圖）就不寫標籤——宣告錯比不宣告糟
    const shareImageSize = computed(() => publicEntry.value?.image ? (publicEntry.value.imageW && publicEntry.value.imageH ? [publicEntry.value.imageW, publicEntry.value.imageH] : null) : [1200, 630]);
    const description = computed(() => route.meta?.description || (isZhPath.value
      ? '吳哲宇 (Che-Yu Wu)：新媒體藝術家、音樂人、教育者。演算法生成會呼吸、會演化的藝術。'
      : 'Che-Yu Wu (吳哲宇): new media artist, musician, and educator. Algorithmic art that breathes and evolves.'));

    useHead({
      script: computed(() => {
        const entry = publicEntry.value;
        const scripts = entry?.schema ? [{ type: 'application/ld+json', innerHTML: JSON.stringify(entry.schema) }] : [];
        // Only this exhibition page pair: keep its existing VisualArtwork intact.
        if (entry?.params?.slug === 'the-last-input' && /^\/(?:zh\/)?exhibition\/the-last-input\/$/.test(entry.path)) {
          const zh = entry.meta.locale === 'zh';
          const venue = zh ? '臺灣當代文化實驗場 C-LAB' : 'Taiwan Contemporary Culture Lab (C-LAB)';
          const common = {
            '@type': 'Event',
            name: entry.schema.name, // 2026-10-18：中文 <title> 改成「名字：類型 年份」，JSON-LD 的 name 照舊（＝作品 schema 的 name，不跟 meta.title）
            // 2026-10-23：颱風假，10/24 延到 11/14，時段不變（哲宇 20:4x）。previousStartDate 是原訂的演出日
            eventStatus: 'https://schema.org/EventRescheduled',
            eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
            location: { '@type': 'Place', name: venue, address: { '@type': 'PostalAddress', addressLocality: 'Taipei', addressCountry: 'TW' } },
            performer: { '@id': 'https://cheyuwu.com/#person' },
          };
          scripts.push({ type: 'application/ld+json', innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            ...common,
            startDate: '2026-11-14',
            endDate: '2026-11-14',
            previousStartDate: '2026-10-24',
            organizer: { '@type': 'Organization', name: venue, url: 'https://clab.org.tw/' },
            url: canonicalUrl.value,
            image: entry.schema.image,
            subEvent: ['2026-11-14T15:00:00+08:00', '2026-11-14T16:30:00+08:00'].map(startDate => ({
              ...common,
              startDate,
              previousStartDate: startDate.replace('2026-11-14', '2026-10-24'),
              description: zh ? '演出與演後座談' : 'Performance followed by an artist talk',
            })),
          }) });
        }
        return scripts;
      }),
      htmlAttrs: computed(() => ({ lang: isZhPath.value ? 'zh-Hant' : 'en' })),
      title: pageTitle,
      // 作者後綴依語系接（中「｜吳哲宇」、英「 | Che-Yu Wu」），人物頁自帶名字的不再接
      titleTemplate: (t) => composeTitle(t, isZhPath.value ? 'zh' : 'en'),
      link: computed(() => [
        ...(publicEntry.value ? [{ rel: 'canonical', href: canonicalUrl.value }] : []),
        ...alternateLinks.value,
        // describedby（llms.txt、manifest）與 service-desc（openapi）三個連結只住在 index.html 的殼裡：
        // 殼是靜態的，不跑 JS 的爬蟲、預渲染之前都讀得到，換頁時也不會被 unhead 清掉。
        // 2026-10-15 之前這裡又宣告一份，預渲染兩份都留下，線上每頁各兩份；
        // scripts/test-ai-discovery.mjs 現在檢查每種恰好一個，且 src 內不得再宣告。
        ...(publicEntry.value?.aiId ? [{ rel: 'alternate', type: 'text/markdown', title: 'Full page Markdown', href: SITE + '/ai/pages/' + publicEntry.value.aiId + '.md' }] : []),
        { rel: 'alternate', type: 'application/atom+xml', title: 'Che-Yu Wu — Thinking', href: SITE + '/feed.xml' },
      ]),
      meta: computed(() => [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'description', content: description.value },
        { property: 'og:site_name', content: siteName },
        { property: 'og:title', content: shareTitle.value },
        { property: 'og:description', content: description.value },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: canonicalUrl.value },
        { property: 'og:locale', content: isZhPath.value ? 'zh_TW' : 'en_US' },
        { property: 'og:locale:alternate', content: isZhPath.value ? 'en_US' : 'zh_TW' },
        { property: 'og:image', content: shareImage.value },
        ...(shareImageSize.value ? [
          { property: 'og:image:width', content: String(shareImageSize.value[0]) },
          { property: 'og:image:height', content: String(shareImageSize.value[1]) },
        ] : []),
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: shareTitle.value },
        { name: 'twitter:description', content: description.value },
        { name: 'twitter:image', content: shareImage.value },
        { name: 'robots', content: route.meta?.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large' },
      ])
    });

    // 新頁掛載：已完成的圖直接顯示、宣告頁面就緒（捲動定位與轉場放行在 router.scrollBehavior）、
    // 非 View Transition 路徑補一個進場淡入、開始預載畫面裡的站內連結。
    const onPageMounted = (vnode) => {
      const el = vnode?.el;
      markCompleteImages(el);
      pageReady(route.path);
      const mode = consumeEnterMode();
      if (mode && el?.classList) {
        const cls = 'page-enter-' + mode;
        el.classList.add(cls);
        setTimeout(() => el.classList.remove(cls), 400);
      }
      observeVisibleLinks(el);
      // 頁首導覽一直在畫面上（桌機），也要先載：只觀察主內容時，線上實測首頁→Works、About→Thinking、
      // Press→Lab 點下去要先等 0.9–1.4 秒的 chunk 才開始轉場。已載過的路徑 prefetch 端會略過。
      observeVisibleLinks(document.querySelector('.site-header'));
    };

    return { onPageMounted, loading, mobileMenuOpen, localizedPath, locale, menuToggle, menuPanel, searchOpen, openSearch, closeSearch, warmSearch };
  },
};
</script>

<style lang="sass">
@import '@/assets/styles/editorial'
@import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i&display=swap')
// Rokkitt：哲宇手寫版 NFT 檔案頁的 slab serif（考古繼承）——集中載一次，取代原本 6 頁各自 @import
@import url('https://fonts.googleapis.com/css2?family=Rokkitt:wght@400;500;600;700&display=swap')
canvas
  position: absolute
  z-index: -1
  left: 0
  top: 0
html
  overflow-x: hidden
\:root
  --font-display: 'Noto Serif TC', 'Songti TC', 'PMingLiU', Georgia, serif
  --font-body: 'IBM Plex Sans', sans-serif
  --font-slab: 'Rokkitt', 'Noto Serif TC', serif
  // 全站寬度系統（2026-07-11）：流體容器，撐滿可用寬度
  // content-w：視覺型網格（作品牆 / 展覽牆 / gallery）
  // editorial-w：文字為主的頁（about / music / writing / cv）
  --content-w: min(94vw, 1840px)
  --editorial-w: min(92vw, 1560px)
  --reading-w: 960px
  // 色彩系統（docs/DESIGN.md）：近單色 gallery 紀律，作品的顏色當主角
  --bg0: #000
  --bg1: #0d0d0f
  --bg2: #16161a
  --line: rgba(255,255,255,0.08)
  --line-2: rgba(255,255,255,0.18)
  --ink: #f4f4f2
  --ink-2: #b4b4b0
  --ink-3: #85858a
  --ink-4: #55555a
  --gold: #d9c267
  --muse-violet: #a088cc
  --side-w: 300px
  // 無框設計（2026-10-03，docs/DESIGN.md §十六）：分組靠留白、字級與底色層次，不靠左邊標線與外框
  --tint-1: rgba(255,255,255,0.035)
  --tint-2: rgba(255,255,255,0.06)
  --tint-3: rgba(255,255,255,0.1)
  --gold-tint: rgba(217,194,103,0.12)
  --violet-tint: rgba(160,136,204,0.12)
  --r-sm: 6px
  --r-md: 12px
  --r-lg: 18px
  --r-pill: 999px
  // 內容類型色（類型標籤的小圓點；字一律 --ink-2，不以顏色為唯一區辨）
  --k-work: #f4f4f2
  --k-exhibition: #d9c267
  --k-dialogue: #b9a6dd
  --k-essay: #d9c267
  --k-talk: #8fc1b5
  --k-teaching: #c9a98a
  --k-press: #c9a98a
  --k-music: #8fc1b5
  --k-td: #8fb3d9
  --k-sketch: #9fd1a8
  --k-lab: #d98c7a
  --k-archive: #85858a
  // 動態 token（2026-09-25 三站動態設計；規格 SSOT＝vault《三站動態設計：從硬切到銜接》§4）
  // 剪接語法：形的延續、不過黑、退場比進場短、只有被點的東西走遠路、減速停下不回彈
  --dur-press: 90ms
  --dur-quick: 160ms
  --dur-exit: 200ms
  --dur-base: 280ms
  --dur-scene: 480ms
  --dur-camera: 560ms
  --dur-signature: 760ms
  --ease-out: cubic-bezier(.22,1,.36,1)
  --ease-in: cubic-bezier(.4,0,1,1)
  --ease-move: cubic-bezier(.4,.14,.3,1)
  --ease-inout: cubic-bezier(.65,0,.35,1)
  // hover 的標準組合：只動顏色、底色、框線色、透明度（不動 padding／border 寬度／位置）
  --t-hover: color var(--dur-quick) var(--ease-out), background-color var(--dur-quick) var(--ease-out), border-color var(--dur-quick) var(--ease-out), opacity var(--dur-quick) var(--ease-out)

::selection
  background: var(--gold)
  color: #000

:focus-visible
  outline: 2px solid var(--gold)
  outline-offset: 2px

// Bootstrap 4 CDN 的 .container 在 >=1200px 鎖 1140px —— 用流體寬度覆寫全部斷點
.container
  max-width: var(--editorial-w)

body
  font-family: var(--font-body)
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  background-color: var(--bg0)
  color: var(--ink)
  // 2026-09-05：body 不能是捲動容器，否則 position: sticky（對話錄左欄綱要）永遠不黏。
  // overflow-x: hidden 或「clip + overflow-y: auto」都會把 body 變成捲動容器；捲動由 html／viewport 負責。
  overflow-x: clip
  overflow-y: visible

// Sticky header：hero 影片上仍可讀（blur + 半透明 + hairline）
.site-header
  position: sticky
  top: 0
  z-index: 900
  background: rgba(0,0,0,0.55)
  backdrop-filter: blur(14px)
  -webkit-backdrop-filter: blur(14px)
  border-bottom: 1px solid var(--line)

// Display serif：大標 / 引句 / 數字（優雅大方層）
.page h1,
.hero-name,
.page-title
  font-family: var(--font-display)

.page
  min-height: 100vh
  // height: auto
  // height: 100vh
  // overflow: hidden
  // border: solid 15px white

h1,h2,h3,h4,h5,h6
  font-weight: bold

nav
  margin: 10px 15px
  font-weight: bold
  display: flex
  justify-content: space-between
  align-items: center
  .main-logo
    display: flex
    align-items: center
    h2
      margin: 0
      line-height: 0
    // 2026-10-04 SVG 標誌：尺寸照舊 PNG 量出來的 WU 符號大小（桌機符號高 29.5px、≤1199px 24px、手機 22px），
    // PNG 四周有留白所以當時用 margin: -10px 抵掉；SVG 已裁切，只補回符號原本的左緣位置
    .brand-logo
      display: block
      width: auto
      height: 31px
      margin-left: 6px
      color: var(--ink)
    .brand-logo-symbol
      height: 23px
      margin-left: 2px

  // 2026-09-25 動態設計：原本 nav／h2／a 都是 transition: 0.5s（動全部屬性，連 padding 一起動）→ 只動顏色
  h2,a
    transition: color var(--dur-quick) var(--ease-out)
  h2
    font-size: 1.5rem
    font-weight: 900
    color: white
  a
    color: white
    &:hover,&.active, &.router-link-exact-active
      // border-bottom: solid 3px
      text-decoration: none
      padding-bottom: 0px
  &.white
    a,h2
      color: white
  // 2026-10-03 對齊：每一格（文字連結、搜尋、語言、IG）都是 44px 高、垂直置中；選中底線改成 ::after，
  // 不再用 border-bottom＋padding-bottom（那會讓選中的那格比別人高 4px，文字跟著往上跑）
  .subroute
    align-items: center
    gap: 6px
    &.white
      color: white
    > a
      position: relative
      display: inline-flex
      align-items: center
      min-height: 44px
      margin: 0
      padding: 0 10px
      font-size: 0.92rem
      font-weight: 500
      line-height: 1
      letter-spacing: 0.03em
      color: var(--ink-3)
      transition: color var(--dur-quick) var(--ease-out)

      &:hover
        color: var(--ink)
      &.active, &.router-link-exact-active
        color: var(--ink)
        padding-bottom: 0
        &::after
          content: ''
          position: absolute
          left: 10px
          right: 10px
          bottom: 9px
          height: 2px
          background: var(--gold)
    > .search-btn
      margin-left: 6px
    > .language-switcher
      min-height: 44px
      font-size: 0.92rem
      color: var(--ink-3)
      white-space: nowrap
    // 2026-10-16 主導覽加「教學」變十項：英文在 1200–1399px 會把 Works & Exhibitions 擠成兩行、「中文」擠成直排。
    // 項目不准換行，這個寬度區間把左右留白收窄（10px → 6px）、間距收到 2px
    > a
      white-space: nowrap
    @media (min-width: 1200px) and (max-width: 1399.98px)
      gap: 2px
      > a
        padding: 0 6px
        letter-spacing: 0.01em
        &.active, &.router-link-exact-active
          &::after
            left: 6px
            right: 6px
    > a.nav-icon
      justify-content: center
      width: 44px
      padding: 0
      font-size: 1.05rem
      &::after
        display: none

  // margin-top: 60px

// 換頁轉場：2026-09-25 起改由 View Transitions（assets/styles/motion.css＋runtime/view-transition.js）。
// 舊的 .page-enter／.page-leave（out-in 各 0.5s、中間全黑）已移除。

.social-links
  pre
    color: #777
    font-size: 0.85rem
    letter-spacing: 0.06em
    margin-top: 10px
  a
    color: #999
    margin-left: 10px
    margin-right: 10px
    font-size: 1.15rem
    transition: color var(--dur-quick) var(--ease-out)
    .icon
      transition: transform var(--dur-quick) var(--ease-out)
    &:hover
      color: var(--ink)
    &:hover .icon
      transform: translateY(-2px)

.site-footer
  border-top: 1px solid var(--line)
  margin-top: 80px

  .footer-inner
    max-width: var(--editorial-w)
    margin: 0 auto
    padding: 56px 16px 8px
    display: grid
    grid-template-columns: repeat(4, 1fr)
    gap: 32px
    text-align: left
    @media (max-width: 768px)
      grid-template-columns: 1fr 1fr
      text-align: left
      gap: 32px 20px
      .footer-col:last-child
        grid-column: 1 / -1
        display: flex
        flex-wrap: wrap
        gap: 4px 20px
        .footer-title
          width: 100%
          margin-bottom: 0
      // 專案欄名字較長（Open AudioVisual 2026），半寬會斷行：手機上撐滿整寬、跟「其他平台」一樣橫排換行，名字與年份不拆開
      .footer-col.footer-projects
        grid-column: 1 / -1
        display: flex
        flex-wrap: wrap
        gap: 4px 20px
        .footer-title
          width: 100%
          margin-bottom: 0
        a
          white-space: nowrap

  .footer-title
    font-size: 0.8rem
    text-transform: uppercase
    letter-spacing: 0.14em
    color: var(--ink-3)   // --ink-4 在黑底只有 2.7:1，Lighthouse 對比稽核；--ink-3 是 5.4:1
    margin-bottom: 14px

  .footer-col
    a
      display: block
      color: var(--ink-3)
      font-size: 0.95rem
      line-height: 2.1
      text-decoration: none
      transition: color var(--dur-quick) var(--ease-out)
      &:hover
        color: var(--gold)
        text-decoration: none
    a.footer-map
      display: flex
      align-items: center
      gap: 8px
      .brand-icon
        width: 18px
        height: 18px

  .footer-era
    font-size: 0.75rem
    color: var(--ink-3)
    margin-left: 8px
    letter-spacing: 0.06em
    font-variant-numeric: tabular-nums

  .footer-base
    padding: 24px 0 40px
    label
      display: block
      text-align: center
      color: var(--ink-4)
      font-size: 0.85rem
      letter-spacing: 0.08em
      margin: 16px 0 0

// 搜尋 icon（桌面在語言切換左邊，手機在 hamburger 左邊）
.mobile-actions
  display: flex
  align-items: center
  gap: 2px
  .search-btn
    color: var(--ink)
    svg
      width: 22px
      height: 22px
    circle, path
      stroke-width: 2
.search-btn
  border-radius: 8px
  &:focus:not(:focus-visible)
    outline: none
  &:focus-visible
    outline: 2px solid var(--gold)
    outline-offset: 2px
  display: inline-flex
  align-items: center
  justify-content: center
  width: 44px
  height: 44px
  padding: 0
  background: none
  border: 0
  color: var(--ink-3)
  cursor: pointer
  transition: color var(--dur-quick) var(--ease-out)
  &:hover
    color: var(--ink)
  svg
    display: block

// Hamburger button
.hamburger
  background: none
  border: none
  cursor: pointer
  padding: 10px
  z-index: 1001
  position: relative
  span
    display: block
    width: 24px
    height: 2px
    background: white
    margin: 5px 0
    transition: transform var(--dur-base) var(--ease-out), opacity var(--dur-quick) var(--ease-out)
  &.open
    span:nth-child(1)
      transform: rotate(45deg) translate(5px, 5px)
    span:nth-child(2)
      opacity: 0
    span:nth-child(3)
      transform: rotate(-45deg) translate(5px, -5px)

// Mobile fullscreen overlay
.mobile-menu-overlay
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100dvh
  overflow-y: auto
  padding: 76px 20px 24px
  background: #0d0d0f
  z-index: 1000
  display: flex
  align-items: center
  justify-content: center

.mobile-menu-content
  display: flex
  flex-direction: column
  align-items: center
  gap: 2px
  margin: auto
  a
    color: white
    font-size: clamp(1.15rem, 3.5vh, 1.8rem)
    font-weight: 600
    letter-spacing: 0.05em
    padding: 6px 20px
    min-height: 44px
    text-decoration: none
    transition: opacity var(--dur-quick) var(--ease-out)
    &:hover
      opacity: 0.6
    // 目前所在的那一頁用金色標出（2026-10-03：原本跟 hover 一樣變半透明，看起來像不能按）
    &.router-link-active
      color: var(--gold)
      opacity: 1
    .menu-sub
      display: block
      text-align: center
      font-size: 0.72rem
      font-weight: 400
      letter-spacing: 0.04em
      color: var(--ink-3)
      margin-top: 1px
    &.menu-social
      margin-top: 22px
      font-size: 0.95rem
      font-weight: 500
      letter-spacing: 0.06em
      color: var(--ink-3)
      display: inline-flex
      align-items: center
      gap: 8px
      .icon
        font-size: 1.15rem

.menu-close
  // 開選單時焦點會移到這顆鍵；觸控與滑鼠不畫框，鍵盤才畫站上的金色細框（2026-10-03，原本是瀏覽器預設藍框）
  &:focus:not(:focus-visible)
    outline: none
  &:focus-visible
    outline: 2px solid var(--gold)
    outline-offset: 3px
  position: absolute
  top: 18px
  right: 20px
  background: var(--tint-2)
  border: 0
  border-radius: var(--r-pill)
  color: var(--ink)
  padding: 10px 20px
  min-height: 44px
  cursor: pointer
  transition: var(--t-hover)
  &:hover
    background: var(--tint-3)

.skip-link
  position: fixed
  z-index: 2000
  top: 8px
  left: 8px
  padding: 12px 18px
  color: #000
  background: var(--ink)
  transform: translateY(-150%)
  &:focus
    transform: translateY(0)

#main-content
  outline: none
  scroll-margin-top: 90px

@media (max-width: 1199px)
  .site-header nav
    margin: 8px 4px
  .site-header .main-logo .brand-logo-primary
    height: 25px
    margin-left: 4px

// 減少動態：動畫只播一次、不延遲（2026-09-25：原本缺 iteration-count，無限循環的動畫會每 0.01ms 重播而閃爍）
@media (prefers-reduced-motion: reduce)
  *, *::before, *::after
    scroll-behavior: auto !important
    animation-duration: 0.01ms !important
    animation-iteration-count: 1 !important
    animation-delay: 0s !important
    transition-duration: 0.01ms !important
    transition-delay: 0s !important

// 手機選單：覆蓋層 280ms 淡入、200ms 淡出；項目上浮 8px、每項錯開 30ms
.menu-fade-enter-active
  transition: opacity var(--dur-base) var(--ease-out)
.menu-fade-leave-active
  transition: opacity var(--dur-exit) var(--ease-in)
.menu-fade-enter-from, .menu-fade-leave-to
  opacity: 0
@keyframes menu-item-in
  from
    opacity: 0
    transform: translateY(8px)
.mobile-menu-content > *
  animation: menu-item-in var(--dur-base) var(--ease-out) both
@for $i from 1 through 12
  .mobile-menu-content > :nth-child(#{$i})
    animation-delay: #{40 + ($i - 1) * 30}ms
</style>
